import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const inventoryDriverObj = (dispatch) => {
  const steps = [
    {
      element: '.exportInventory',
      popover: {
        title: 'Export Inventory',
        description: 'Click here to export inventory data to CSV format for further analysis or record keeping.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.importInventory',
      popover: {
        title: 'Import Inventory',
        description: 'Click here to import inventory data from CSV format for further analysis or record keeping.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.inventoryFiltersToggleButton',
      popover: {
        title: 'Filters Toggle Button',
        description: 'Click here to toggle the filter menu to filter inventory items.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.createInventory',
      popover: {
        title: 'Create New Item',
        description: 'Add new items to your inventory with details like name, quantity, location, etc.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.inventoryFilters',
      popover: {
        title: 'Inventory Filters',
        description:
          'Use these filters to narrow down inventory items based on various criteria like category, status, etc.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.inventoryTable',
      popover: {
        title: 'Inventory Overview',
        description: 'View all your inventory items in this table.',
        side: 'left',
        align: 'start',
      },
    },
    {
      element: '.inventoryActions',
      popover: {
        title: 'Inventory Actions',
        description: 'You can edit, delete and also make transactions to the inventory items.',
        side: 'left',
        align: 'start',
      },
    },
  ].filter((step) => document.querySelector(step.element) !== null);

  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps,
  });
  return driverObj;
};

export default inventoryDriverObj;
